import { useStaticQuery, graphql } from "gatsby";
import React, {useEffect, useState} from "react";
import {Col, Row, Container, Button } from 'react-bootstrap';
import ReactMarkdown from "react-markdown"
import { Link } from "@StarberryUtils";
import headingBgImg from '../images/local_love_heading_bg_img.png'
import MgLocalLoveLogo from '../images/mg_logo_local.svg'
import axios from 'axios';
import { useLocation } from "@reach/router"
import ModalTiny from "react-bootstrap/Modal"
import CommentForm from "./forms/comments-reviews"


const LikeCommentBlock = ({url, strapiId, name, commites, link}) => {

    // strapi axios - start
    const baseURL = `${process.env.GATSBY_STRAPI_FORM_URL}`;
    const token = process.env.GATSBY_STRAPI_FORM_TOKEN;

    const [likesicon,setLikesicon] = useState("icon-heart-likes-1");//like icon
    const [ip, setIP] = useState('');//client ip value
    const [likescount,setLikescount] = useState(0); // like count of this current article
    const [likesarr,setLikesarr] = useState([]); // total likes in array format
    const [ipliked,setIpliked] = useState(0); // flag whether liked or not
    const [igotcount,setIgotcount] = useState(0); // flag whether get the like count or not
    const [likestrapiid,setLikestrapiid] = useState(''); // article's trapi id for delete mutation

    const [modalCommentformOpen,setCommentformOpen] = React.useState(false);
    const openCommentformModal = () => {
        setCommentformOpen(true);
    }
    const closeCommentformModal = () => {
        setCommentformOpen(false);
    }

    var count = commites.filter(({node}) => node.local_life_things_to_do?.URL === url).length
    const location = useLocation();
    const shareUrl = location.href
    const trackerShare = (event) => {    
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'Share - social icons',
        'formType': event + ' - ' +shareUrl,
        'formId': 'Share',
        'formName': 'Share',
        'formLabel': 'Share'
      });    
  }
  

    const authInstance = axios.create({
      baseURL: baseURL,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": 'application/json' // we are sending json format to graphql
      },
    });

    const getLikesCount = async (url) => {
      var mypostdata = await JSON.stringify({"query":"query myquery($url: String) { localLifeLikes (where: {local_life_things_to_do: {URL: $url} } ) { id, ip_address } }","variables":{"url": url}});
      authInstance.post('graphql',mypostdata).then(response => {
        setLikescount(response?.data.data?.localLifeLikes?.length);
        setLikesarr(response?.data.data?.localLifeLikes)
        setIgotcount(1)
      });
    }

    const deleteLike = async (myId) => {
      var mypostdata = JSON.stringify({"query":"mutation deleteLikes ($id: ID!) { deleteLocalLifeLike(input: { where: { id: $id } }) { localLifeLike { id } } }","variables":{"id": myId}});
    
        authInstance.post('graphql',mypostdata).then(response => {
          console.log("likes removed")
          setIpliked(2)
        });
      }
  
    //function to do call create mutation like record
    const addLike = async (ipaddr, strapiid) => {
    var mypostdata = JSON.stringify({"query":"mutation myaddlikes ($ipaddr: String!, $strapiid: ID) { createLocalLifeLike(input: { data: { ip_address: $ipaddr, local_life_things_to_do: $strapiid } }) { localLifeLike { id } } }","variables":{"ipaddr": ipaddr, "strapiid": strapiid}});
  
      authInstance.post('graphql',mypostdata).then(response => {
        console.log("likes added");
        setIpliked(1)
        setLikestrapiid(response?.data?.data?.createLocalLifeLike?.localLifeLike?.id)
      });
    }
  
    //function to cross check whether this ip liked this article
    const chkLiked = (ip, likesarr) => {
      let fillheart = likesarr.some(function(item) {
        return item.ip_address == ip
      });
      if(fillheart){
        setLikesicon("icon-heart-likes-fill");
        setIpliked(1); // 1 means liked
      } else {
        setIpliked(2); // 2 means like removed
      }
      likesarr.some(function(item) {
        if( item.ip_address == ip ) {
          setLikestrapiid(item.id) // we need this id for deletion
        }
      });
    }
  


    const likesaction = () => {
      if(ipliked == 1){ // liked already
        setLikescount(likescount - 1)
        setLikesicon("icon-heart-likes-1");
        if(likestrapiid) {
          deleteLike(likestrapiid)
        }
        setIpliked(2) // 2 means like removed
      }
      if(ipliked == 2){
        setLikesicon("icon-heart-likes-fill");
        setLikescount(likescount + 1)
        if(ip && strapiId) {
          addLike(ip, strapiId)
        }
        setIpliked(1) // 1 means liked
      }
    }

    const getIPData = async () => {
      const res = await axios.get('https://geolocation-db.com/json/')
      setIP(res.data.IPv4)
    }



    useEffect( () => {
      if(!ip) {
        getIPData()
      }
      if(igotcount == 0){
        getLikesCount(url)
      }
      if(ipliked == 0 && ip && igotcount == 1) {
        chkLiked(ip, likesarr)
      }
    }, [url, ip, ipliked, likesarr])
    


  return (
    <div className="d-flex like_comment_block">
      <p onClick={likesaction} className="like_icon" ><i className={`${likesicon} ml-3`} ></i><span> {likescount} Likes</span></p>
      <Link className="comment_icon" to={link}><i className="icon-comment-blue ml-3" ></i><span>{count} Comments</span></Link>
      <ModalTiny backdrop="static" show={modalCommentformOpen} onHide={closeCommentformModal} className="book-a-viewing-modal share-to-friend-modal">
        <ModalTiny.Header closeButton className="contact-close-btn">
            <ModalTiny.Title className="w-100"><h2 className="text-center mb-0 text-uppercase">ADD COMMENTS</h2></ModalTiny.Title>
        </ModalTiny.Header>
        <ModalTiny.Body className="event-section"><CommentForm local_life_id={strapiId} local_life_name={name} /></ModalTiny.Body>
      </ModalTiny>
    </div>
  )
}


export default LikeCommentBlock